if (!customElements.get('seed-hint')) {
  class SeedHint extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      this.endDate = Number(this.dataset.campaignEnd) * 1000;
      if (!Number.isFinite(this.endDate) || this.endDate <= 0) return;

      this.checkExpiry = this.updateCampaign.bind(this);
      document.addEventListener('visibilitychange', this.checkExpiry);
      this.updateCampaign();
    }

    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.checkExpiry);
    }

    updateCampaign() {
      clearTimeout(this.expiryTimer);
      const normalHint = this.querySelector('template');
      if (!normalHint) return;

      const remaining = this.endDate - Date.now();
      if (remaining <= 0) {
        this.replaceChildren(normalHint.content.cloneNode(true));
        document.removeEventListener('visibilitychange', this.checkExpiry);
        return;
      }

      this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
    }
  }

  customElements.define('seed-hint', SeedHint);
}
